
import React from 'react';
import { FormFieldType } from '@/types/form';
import FieldWrapper from '../FieldWrapper';
import WorksheetSelector from './WorksheetSelector';
import OtherSubjectCheckbox from './OtherSubjectCheckbox';
import { useWorksheetSelection } from './useWorksheetSelection';

interface WorksheetSearchFieldProps {
  element: FormFieldType;
}

export const WorksheetSearchField: React.FC<WorksheetSearchFieldProps> = ({ element }) => {
  const {
    otherSubject,
    setSearchQuery,
    isLoading,
    handleSelectWorksheet,
    handleOtherSubjectChange,
    options,
    selectedOption
  } = useWorksheetSelection({
    element,
    otherSubjectField: 'other_subject',
    subjectDataField: 'subject_data',
    worksheetIdField: 'worksheet_id'
  });

  return (
    <FieldWrapper element={element}>
      <div className="space-y-4">
        <WorksheetSelector
          options={options}
          value={selectedOption}
          onChange={handleSelectWorksheet}
          onInputChange={setSearchQuery}
          isLoading={isLoading}
          disabled={otherSubject}
        />
        
        <OtherSubjectCheckbox
          id="other-subject"
          checked={otherSubject}
          onChange={handleOtherSubjectChange}
        />
      </div>
    </FieldWrapper>
  );
};

export default WorksheetSearchField;
